import { rand } from '@helpers/javascript/date_helpers'

export const addMaterialPlacementAction = (workorder, action, choice) => dispatch =>
  dispatch({
    type:    ADD_MATERIAL_PLACEMENT.ACTION,
    payload: { workorder, action, choice }
  })

export const removeMaterialPlacementAction = (workorder, materialPlacement) => dispatch =>
  dispatch({
    type:    REMOVE_MATERIAL_PLACEMENT.ACTION,
    payload: { workorder, materialPlacement }
  })

export const ADD_MATERIAL_PLACEMENT = {
  ACTION: 'ADD_MATERIAL_PLACEMENT',

  call: ({ state, workorder, action, choice }) => (
    {
      ...state,
      items: state.items.map(item => item.id != workorder.id ? item : {
        ...item,
        synced: false,
        material_placements: [...(item.material_placements || []), {
          version:       rand(1e7),
          action,
          material_id:   choice.material_id,
          serial_number: choice.serial_number,
          name:          choice.name
        }]
      })
    }
  )
}

export const REMOVE_MATERIAL_PLACEMENT = {
  ACTION: 'REMOVE_MATERIAL_PLACEMENT',

  call: ({ state, workorder, materialPlacement }) => (
    {
      ...state,
      items: state.items.map(item => item.id != workorder.id ? item : {
        ...item,
        synced: false,
        material_placements: (item.material_placements || []).flatMap(line => {
          if (line !== materialPlacement) return [line]
          return line.id ? [{ ...line, _destroy: true }] : []
        })
      })
    }
  )
}
